module.exports = __webpack_public_path__ + "img/34.f5619374.jpg";